import React from 'react';

type DefaultLayoutProps = {
  children?: React.ReactNode;
  className?: string;
};

const DefaultLayout = ({ children, className }: DefaultLayoutProps) => {
  return (
    <main className={`flex h-full items-center content-center ${className}`}>
      {children}
    </main>
  );
};

export default DefaultLayout;
